module.exports = __webpack_public_path__ + "images/emoji/ab.636acfbb41155b18a8f1.png";